import { Configuration } from '../Configuration';
import { ConfigurationDto } from '../ConfigurationDto';

import { voiceDtoToVoice } from './voiceMapper';

export const configurationDtoToConfiguration = ({
	isExtensionEnabled,
	config: { voiceTime, costInBits },
	voices,
}: ConfigurationDto): Configuration => ({
	voices: voices.map((voice) => voiceDtoToVoice(voice, costInBits)),
	isEnabled: isExtensionEnabled,
	defaultTimeSeconds: voiceTime,
});
